import { Injectable } from '@angular/core';
import { AddCompanyContactRoleErrorService } from './add-company-contact-role.handler';
import { CbreAlertService } from '@cbre/alerts';
import { L10nTranslationService } from 'angular-l10n';
import { MainFormService } from '@records/controls/record-container/main-form.service';

@Injectable({
  providedIn: 'root',
})
export class MethodErrorHandlerFactoryService {
  constructor(
    private cbreAlertService: CbreAlertService,
    private translationService: L10nTranslationService,
    private mainFormService: MainFormService
  ) {}

  public getHandlerError(failingMethodName: string) {
    switch (failingMethodName) {
      case 'addCompanyContactRole':
      case 'addPropertyCompanyContactRole':
        return new AddCompanyContactRoleErrorService(
          this.cbreAlertService,
          this.translationService,
          this.mainFormService
        );
      default:
        return null;
    }
  }
}
